import { showBoclipsSearch, showDatabaseSearch } from "config";

const baseSources = [
  { label: "By Categories", key: "categories", default: true },
  { label: "By Media Bias", key: "rating" },
  { label: "Peer Reviewed", key: "peer-reviewed" },
  { label: "Partner Publishers", key: "partner-publishers" },
  { label: "Books", key: "books" },
  { label: "Encyclopedia & Dictionary", key: "wiki" },
];

export const sources = showDatabaseSearch
  ? [
      ...baseSources.slice(0, 2),
      { label: "Databases", key: "databases" },
      ...baseSources.slice(2),
    ]
  : baseSources;

export const boClipsLabel = "Videos";

export const ebscoLabel = "EBSCO";
export const proQuestLabel = "ProQuest";

export const databaseCategories = [
  { label: ebscoLabel, key: "ebsco" },
  { label: proQuestLabel, key: "proquest" },
];

const baseCategories = [
  { label: "Global News", key: "global-news" },
  { label: "Periodicals & Specialty News", key: "periodics" },
  { label: "Think Tanks", key: "think-tanks" },
  { label: "Academia & Scholarly Resources", key: "academia" },
  { label: "Other Selected Sources", key: "others" },
  { label: "US Government", key: "us-government" },
  { label: "Intergovernmental Organizations", key: "intergovernment" },
];

export const getCategories = (isHomeschool = false) => {
  const categories = [...baseCategories];
  if (showBoclipsSearch || isHomeschool) {
    categories.push({ label: boClipsLabel, key: "boclips" });
  }
  return categories;
};

export const categories = getCategories();

export const academicSources = [
  { label: "CORE", key: "1" },
  { label: "Semantic Scholar", key: "2" },
  { label: "Arxiv", key: "3" },
  { label: "Springer Nature", key: "4" },
  { label: "PLOS", key: "5" },
];

export const publishersArray = [
  { label: "The Christian Science Monitor", key: "The Christian Science Monitor" },
  { label: "Business Insider",                 key: "Business Insider" },
  // { label: "The Economist",                 key: "The Economist" },
  { label: "Foreign Policy",                key: "Foreign Policy" },
  { label: "MIT Technology Review",         key: "MIT Technology Review" },
  { label: "The Nation",                    key: "The Nation" },
  { label: "The New Republic",              key: "The New Republic" },
  { label: "Project Syndicate",             key: "Project Syndicate" },
  { label: "The Washington Post",           key: "The Washington Post" },
  { label: "The Washington Times",          key: "The Washington Times" },
];

export const biasCategories = [
  { label: "Left & Lean Left", key: "Left" },
  { label: "Center", key: "Center" },
  { label: "Right & Lean Right", key: "Right" },
];

export const frequencies = [
  { label: "Past 24 hours", key: "past-day" },
  { label: "Past Week", key: "past-week" },
  { label: "Past Month", key: "past-month" },
  { label: "Past Year", key: "past-year" },
  { label: "Past 2 Years", key: "past-two-years" },
  { label: "Past 3 Years", key: "past-three-years" },
  { label: "All time", key: "all-time", default: true },
  { label: "Custom Date", key: "custom-date" },
];
